import axios from "axios";
import config from "@/config";

export default {

  createLeaveYear(data){
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL
    });
    return http.post(`takeleavemaster`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid
      }
    });
  },
  updateLeaveYear(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL
    });
    return http.put(`takeleavemaster`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid
      }
    });
  },
  getDetailsLeaveByCode(code,yearLeave) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL
    });
    return http.get(`/takeleavemaster/getDetailsbycode`, {
      params: {
        code: code,
        yearLeave:yearLeave,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid
      }
    });
  },

  getEmployeeLeaveList(branch, dep, position, search, page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
        baseURL: config.API_URL
    });
    return http.get(`/takeleavemaster/findEmpListByBranch`, {
 
        params: {
            'branch': branch,
            'dep': dep,
            'position': position,
            'search': search,
            'page': page,
            companyid: _company_guid,
        },
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + _token,
            'X-TenantID': _company_guid
        }
    });
},

checkleaveList(emp_code,yearLeave){
  const _token = localStorage._token;
  const _company_guid = localStorage._company_guid;
  const http = axios.create({
    baseURL: config.API_URL
  });
  return http.get(`/takeleavemaster/getcheckleave`, {
    params: {
      emp_code:emp_code,
      yearLeave:yearLeave,
      companyid: _company_guid,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + _token,
      "X-TenantID": _company_guid
    }
  });
},
getTimeCheckInByEmp(begin_date,end_date,usercode){
  const _token = localStorage._token;
  const _company_guid = localStorage._company_guid;
  const http = axios.create({
    baseURL: config.API_URL
  });
  let uri = null;
    uri = '/salaryplan/Byuser/' + begin_date + "/" + end_date + "/" + usercode;
  return http.get(uri, {
    params: {
      companyid: _company_guid,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + _token,
      "X-TenantID": _company_guid
    }
  });
},

  
  
};